module.exports = __webpack_public_path__ + "static/img/topbottom.7269ed5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/topbottom.png
// module id = DtPA
// module chunks = 1